import { triggerSimpleAjax } from '../../helpers/httpHelper';
import { GET_RSA_PDF_LINK } from '../../helpers/constants/apiUrl';

export function getRsaPdfLink(outlet_id, rsa_file_slug) {
  return new Promise((resolve, reject) => {
    const url = GET_RSA_PDF_LINK(outlet_id, rsa_file_slug);
    triggerSimpleAjax(
      url,
      'GET',
      {},
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
